import { ActionType } from "../../../../../../../../react-core/Flux/ActionType";
import { ClientAccountClient } from "../../../../../../../../Wrap/Api/Account/ClientAccount";
import { ClientRDRClient } from "../../../../../../../../Wrap/Api/Account/ClientRDR";
import { CorrespondenceRecipientClient } from "../../../../../../../../Wrap/Api/Account/CorrespondenceRecipient";
import { MailingPreferenceHistoryClient } from "../../../../../../../../Wrap/Api/Account/MailingPreferenceHistory";
import { AccountRolesClient } from "../../../../../../../../Wrap/Api/Customer/AccountRoles";
import { AvailableAccountRoleClient } from "../../../../../../../../Wrap/Api/Customer/AvailableAccountRole";
import { InterestedPartyClient } from "../../../../../../../../Wrap/Api/Customer/InterestedParty";
import { OrganisationClient } from "../../../../../../../../Wrap/Api/Customer/Organisation";
import { CustomerRegulationComplianceClient } from "../../../../../../../../Wrap/Api/Regulations/CustomerRegulationCompliance";
import { AccountRoleActorCategory } from "../../../../../../../../Wrap/Constants/Enums/AccountRoleActorCategory";
import { ControllingPersonType } from "../../../../../../../../Wrap/Constants/Enums/Customer/ControllingPersonType";
import { RoleType } from "../../../../../../../../Wrap/Constants/Enums/RoleType";
import { AccountRole } from "../../../../../../../../Wrap/Models/Domains/Account/AccountRole";
import { CorrespondenceRecipient } from "../../../../../../../../Wrap/Models/Domains/Account/CorrespondenceRecipient";
import { MailingPreferenceHistoryCollection } from "../../../../../../../../Wrap/Models/Domains/Account/MailingPreferenceHistoryCollection";
import { ClientAccount } from "../../../../../../../../Wrap/Models/Domains/Account/SlAccounts/ClientAccount";
import { CustomerCompliance } from "../../../../../../../../Wrap/Models/Domains/Regulations/CustomerCompliance";
import { FullClientDetailModel } from "../../../../../../../../Wrap/Models/Models/Customer/FullClientDetailModel";
import { PostProspectResponse } from "../../../../../../../../Wrap/Models/Models/Customer/PostProspectResponse";
import { ClientAccountDispatcher } from "../../../../../../Stroes/Variable";

export class AccountInfoAction {
    public static getAccountRoles(hierarchyId: string, callBack: (data: Array<AccountRole>) => void): void {
        const client = new AccountRolesClient();
        const promise = client.get(hierarchyId);
        promise.onSuccess((data) => {
            if (callBack) {
                callBack(data);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getClientAccount(hierarchyId: string, callBack?: (val: ClientAccount) => void): void {
        const client = new ClientAccountClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((result) => {
            ClientAccountDispatcher.dispatch({ payload: result, actionType: ActionType.Success });
            if (callBack) {
                callBack(result);
            }
        });
        promise.onError((err) => {});
    }

    public static getClientRDR(accountId: string, callBack?: (val: ClientAccount) => void): void {
        const client = new ClientRDRClient();
        const promise = client.get(accountId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
        promise.onError((err) => {});
    }

    public static getPaperlessChangeHistory(
        hierarchyId: string,
        minrow: number,
        maxrow: number,
        callBack?: (val: MailingPreferenceHistoryCollection) => void
    ): void {
        const client = new MailingPreferenceHistoryClient();
        const promise = client.get(hierarchyId, minrow, maxrow);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
        promise.onError((err) => {});
    }

    public static getCustomerRegulationCompliance(
        customerId: number,
        callBack?: (val: Array<CustomerCompliance>) => void
    ): void {
        const client = new CustomerRegulationComplianceClient();
        const promise = client.get(customerId);
        promise.onSuccess((data) => {
            if (callBack) {
                callBack(data);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static updateCustomerRegulationCompliance(
        command: CustomerCompliance,
        callBack?: (val: PostProspectResponse) => void
    ): void {
        const client = new CustomerRegulationComplianceClient();
        const promise = client.put(command);
        promise.onSuccess((data) => {
            if (callBack) {
                callBack(data);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static createCustomerRegulationCompliance(
        command: CustomerCompliance,
        callBack?: (val: PostProspectResponse) => void
    ): void {
        const client = new CustomerRegulationComplianceClient();
        const promise = client.post(command);
        promise.onSuccess((data) => {
            if (callBack) {
                callBack(data);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getAvailableAccountRoleTypes(
        investorTypes: number[],
        customerId: string,
        hierarchyIds: string[],
        callback
    ) {
        const client = new AvailableAccountRoleClient();
        const promise = client.get(investorTypes, Number(customerId), hierarchyIds);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => console.error(err));
    }

    public static createInterestedParty(
        actorCategory: AccountRoleActorCategory,
        hierarchyIds: string[],
        roleType: RoleType,
        clientPortalAccess: boolean,
        data: FullClientDetailModel,
        controllingpersonType: ControllingPersonType,
        callback
    ) {
        const client = new InterestedPartyClient();
        const promise = client.post(
            actorCategory,
            hierarchyIds,
            roleType,
            clientPortalAccess,
            data,
            controllingpersonType
        );
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => console.error(err));
    }

    public static updateAccountRole(
        hierarchyId: string,
        roleType: RoleType,
        clientPortalAccess: boolean,
        data: FullClientDetailModel,
        controllingpersonType: ControllingPersonType,
        callback
    ) {
        const client = new InterestedPartyClient();
        const promise = client.put(hierarchyId, roleType, clientPortalAccess, data, controllingpersonType);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => console.error(err));
    }

    public static deleteInterestedParty = (
        actorId: string,
        accountHierarchyId: string,
        roleType: RoleType,
        callback
    ) => {
        const client = new InterestedPartyClient();
        const promise = client.delete(Number(actorId), accountHierarchyId, roleType);
        promise.onSuccess((data) => {
            callback(data);
        });
        promise.onError((err) => console.error(err));
    };

    public static getOrganisationDetail(id: number, hierarchyId: string, callBack) {
        const client = new OrganisationClient();
        const promise = client.get(id, hierarchyId);
        promise.onSuccess((data) => {
            if (callBack) {
                callBack(data);
            }
        });
        promise.onError((err) => {
            console.log(err);
        });
    }

    public static getCorrespondenceRecipient(hierarchyId: string, callBack?: (val: CorrespondenceRecipient) => void) {
        const client = new CorrespondenceRecipientClient();
        const promise = client.get(hierarchyId);

        promise.onSuccess((result) => {
            if (callBack) {
                callBack(result);
            }
        });
    }

    public static putCorrespondenceRecipient(recipient: CorrespondenceRecipient, callBack: () => void) {
        const client = new CorrespondenceRecipientClient();
        const promise = client.put(recipient);

        promise.onSuccess(() => {
            if (callBack) {
                callBack();
            }
        });
    }
}
